<template>
  <section class="welcome section" id="welcome">
    <div class="bottom">
      <div class="wrapper">
        <div class="row center-xs middle-xs">
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 item">
              <p>{{api.telefone}}</p>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 item">
              <p>{{api.endereco}}</p>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 item">
              <p>{{api.e_mail}}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WelcomeSection',
  props: ['api'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  #welcome
    height 100vh
    background url('../assets/welcome-bg.jpg') center no-repeat
    background-size cover
    color white
    .bottom
      position absolute
      bottom 0
      width 100%
      .item
        border 2px solid white
        border-bottom 0
        padding 20px
        &:nth-child(2)
          border-left 0
          padding 8px 20px
          border-right 0
    @media (max-width 1085px)
      .bottom
        .item
          &:nth-child(2)
            border 2px solid white
            border-bottom 0
</style>



// WEBPACK FOOTER //
// src/components/WelcomeSection.vue